<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessagesGetList.length > 0"
    :show="true"
    :messages="errorMessagesGetList"
  />
  <empty-list
    v-else-if="
      !loading && errorMessagesGetList.length === 0 && items.length === 0
    "
    :srcImage="require('@/assets/images/database-empty.png')"
    btnText="ایجاد دیتابیس"
    @btnCreateClicked="changeToCreateDbRoute"
  >
    <template v-slot:messages>
      <p>
        <strong>اولین دیتابیس خود را ایجاد کنید.</strong>
      </p>
    </template>
  </empty-list>
  <main-page-service
    v-else
    title="لیست دیتابیس‌های ایجاد شده"
    btnText="ایجاد دیتابیس"
    @btnCreateClicked="changeToCreateDbRoute"
  >
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
    >
      <template #cell(picture)="data">
        <img :src="data.item.picture" alt="" style="width: 50px" />
      </template>

      <template #cell(status)="data">
        <span
          class="bn btn-danger btn-sm"
          v-if="data.item.status === 'Stopped'"
        >
          متوقف شده
        </span>
        <span
          class="bn btn-success btn-sm"
          v-else-if="data.item.status === 'Running'"
        >
          درحال اجرا
        </span>
      </template>
      <template #cell(operation)="data">
        <b-button
          size="sm"
          variant="outline-info"
          class="table-list-operation"
          :to="`/database/${data.item.id}/details`"
        >
          <b-icon icon="eye-fill"></b-icon>
        </b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          class="table-list-operation"
          @click="showDeleteModal(data.item.name, data.item.id)"
        >
          <b-icon icon="trash-fill"></b-icon>
        </b-button>
      </template>
    </b-table>
    <delete-database-modal
      :service="serviceForDelete"
      :visible="visibleDeleteModal"
      @hidden="hiddenDeleteModal"
      @deleteSuccess="getListDatabase"
    />
  </main-page-service>
</template>

<script>
import MainPageService from "@/components/MainPageService/MainPageService";
import { userService } from "@/services/service";
import Loading from "@/components/Loading/Loading.vue";
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import DeleteDatabaseModal from "./DeleteDatabaseModal.vue";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "AppList",
  components: {
    MainPageService,
    Loading,
    EmptyList,
    DeleteDatabaseModal,
    ErrorMessages
  },
  data() {
    ErrorMessages;
    return {
      loading: false,
      fields: [
        {
          key: "name",
          label: "شناسه دیتابیس",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "picture",
          label: "نوع",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "status",
          label: "وضعیت",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "createdAt",
          label: "تاریخ ایجاد",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "operation",
          label: "عملیات",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      items: [],
      errorMessagesGetList: [],
      // delete modal data
      serviceForDelete: {},
      visibleDeleteModal: false
    };
  },
  mounted() {
    this.getListDatabase();
  },
  methods: {
    changeToCreateDbRoute: function() {
      this.$router.push("/database/create");
    },
    getListDatabase: async function() {
      this.loading = true;
      const [error, data] = await userService("1");
      if (error) {
        this.loading = false;
        this.errorMessagesGetList = error;
      } else {
        if (data.apiStatus === 200) {
          this.loading = false;
          data.apiData.map(item => {
            item["picture"] = item.picture.replace("files", "file");
            item["operation"] = "";
          });
          this.items = data.apiData;
        } else {
          this.loading = false;
          this.errorMessagesGetList = data.apiErrors;
        }
      }
    },
    //  delete modal method
    showDeleteModal: function(name, id) {
      this.serviceForDelete = { name: name, id: id };
      this.visibleDeleteModal = true;
    },
    hiddenDeleteModal: function() {
      this.visibleDeleteModal = false;
    }
  }
};
</script>

<style></style>
